import axios from "axios";
import "./Cars.css";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

export default function Cars() {
  const headers = {
    token: localStorage.getItem("userToken"),
  };

  const [carsData, setCarsData] = useState([]);

  async function getCarData() {
    try {
      const response = await axios.get(
        `https://vehex-production.up.railway.app/car/allCars`
      );
      setCarsData(response.data.cars);
    } catch (error) {
      console.error("Error fetching car data:", error);
    }
  }
  console.log(carsData);

  async function deleteCarData(id) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let response = await axios.delete(
            `https://vehex-production.up.railway.app/car/deleteCarAdmin/${id}`,
            { headers }
          );
  
          if (response.data.message === "Car deleted successfully.") {
            Swal.fire({
              title: "Deleted!",
              text: "The car has been deleted.",
              icon: "success",
              confirmButtonColor: "#3085d6",
            });
            getCarData();
          }
        } catch (error) {
          console.error("Error deleting car:", error);
          Swal.fire({
            title: "Error!",
            text: "There was an issue deleting the car.",
            icon: "error",
            confirmButtonColor: "#d33",
          });
        }
      }
    });
  }

  useEffect(() => {
    getCarData();
  }, []);

  console.log(carsData);
  

  return (
    <>
      <div className=" overflow-x-auto">
        {carsData?.length>0?<>        <table className=" table table-striped">
          <thead>
            <tr>
              <th>Engine Number</th>
              <th>Agency</th>
              <th>Model</th>
              <th>Year</th>
              <th>Mileage</th>
              <th>Warranty</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {carsData.map((carData) => (
              <tr key={carData._id}>
                <td>
                  {carData?.engineNumber ? carData?.engineNumber : "______"}
                </td>
                <td>
                  {carData?.carDetails?.agency
                    ? carData?.carDetails?.agency
                    : "______"}
                </td>
                <td>
                  {carData?.carDetails?.model
                    ? carData?.carDetails?.model
                    : "______"}
                </td>
                <td>
                  {carData?.carDetails?.year
                    ? carData?.carDetails?.year
                    : "______"}
                </td>
                <td>{carData?.mileage ? carData?.mileage : "______"}</td>
                <td>{carData?.carDetails?.warranty ? "true" : "False"}</td>
                <td>
                  <button
                    className="btn btn-danger"
                    onClick={() => deleteCarData(carData._id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table></>:<div className="main-color fs-5 fw-500 text-center">No User's Car Found </div>}

      </div>
    </>
  );
}
